// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/leftUnderMenu/learning.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/leftUnderMenu/plus-color.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/leftUnderMenu/upcoming-color.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboardLeftBottom{
    display: flex;
    justify-content: space-between;
    padding: 0px 18px;
    padding-top: 24px;
    border-top: 1px solid #989fc91f;
}

.dashboardLeftBottom_button{
    width: 32px;
    height: 32px;
    flex-shrink: 0;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    filter: saturate(0) brightness(1.25);
}

.dashboardLeftBottom_button--learning{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.dashboardLeftBottom_button--plus{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.dashboardLeftBottom_button--upcoming{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.dashboardLeftBottom_button--avatar{
    border-radius: 100%;
    background-color: #ccc;
}

.dashboardLeftBottom_button--active{
    filter: saturate(1) brightness(1);
}

.dashboardLeftBottom_button:hover{
    filter: saturate(0.3) brightness(1.25);
}

.dashboardLeftBottom_button--active:hover{
    filter: saturate(1) brightness(1);
}

.dashboardLeftBottom_button_border_wrap{
    position: relative;
}
.dashboardLeftBottom_button_border{
    position: absolute;
    border-radius: 100%;
    border: 2px solid #f90;

    width: calc(100% + 6px);
    height: calc(100% + 6px);
    top: -3px;
    left: -3px;
}`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/DashboardLeftBottom.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;IACjB,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,wBAAwB;IACxB,2BAA2B;IAC3B,4BAA4B;IAC5B,oCAAoC;AACxC;;AAEA;IACI,yDAAgE;AACpE;;AAEA;IACI,yDAAkE;AACtE;;AAEA;IACI,yDAAsE;AAC1E;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;;IAEtB,uBAAuB;IACvB,wBAAwB;IACxB,SAAS;IACT,UAAU;AACd","sourcesContent":[".dashboardLeftBottom{\n    display: flex;\n    justify-content: space-between;\n    padding: 0px 18px;\n    padding-top: 24px;\n    border-top: 1px solid #989fc91f;\n}\n\n.dashboardLeftBottom_button{\n    width: 32px;\n    height: 32px;\n    flex-shrink: 0;\n    background-size: contain;\n    background-position: center;\n    background-repeat: no-repeat;\n    filter: saturate(0) brightness(1.25);\n}\n\n.dashboardLeftBottom_button--learning{\n    background-image: url(\"../../assets/leftUnderMenu/learning.svg\");\n}\n\n.dashboardLeftBottom_button--plus{\n    background-image: url(\"../../assets/leftUnderMenu/plus-color.png\");\n}\n\n.dashboardLeftBottom_button--upcoming{\n    background-image: url(\"../../assets/leftUnderMenu/upcoming-color.png\");\n}\n\n.dashboardLeftBottom_button--avatar{\n    border-radius: 100%;\n    background-color: #ccc;\n}\n\n.dashboardLeftBottom_button--active{\n    filter: saturate(1) brightness(1);\n}\n\n.dashboardLeftBottom_button:hover{\n    filter: saturate(0.3) brightness(1.25);\n}\n\n.dashboardLeftBottom_button--active:hover{\n    filter: saturate(1) brightness(1);\n}\n\n.dashboardLeftBottom_button_border_wrap{\n    position: relative;\n}\n.dashboardLeftBottom_button_border{\n    position: absolute;\n    border-radius: 100%;\n    border: 2px solid #f90;\n\n    width: calc(100% + 6px);\n    height: calc(100% + 6px);\n    top: -3px;\n    left: -3px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
